import { Injectable } from '@angular/core';
interface Script {
  name: string;
  src: string;
}
export const ScriptStore: Script[] = [
  { name: 'jquery', src: '../../../assets/scripts/jquery.min.js' },
  { name: 'dataTables', src: '../../../assets/scripts/jquery.dataTables.min.js' },
  { name: 'jszip', src: '../../../assets/scripts/jszip.js' },
  { name: 'dataTables-buttons', src: '../../../assets/scripts/dataTables.buttons.js' },
  { name: 'colVis', src: '../../../assets/scripts/buttons.colVis.js' },
  { name: 'flash', src: '../../../assets/scripts/buttons.flash.js' },
  { name: 'html5', src: '../../../assets/scripts/buttons.html5.js' },
  { name: 'buttons-print', src: '../../../assets/scripts/buttons.print.js' },
  { name: 'dataTables-select-min', src: '../../../assets/scripts/dataTables.select.min.js' },
  { name: 'pdf-min', src: '../../../assets/scripts/pdfmake.min.js' },
  { name: 'vfs_fonts', src: '../../../assets/scripts/vfs_fonts.js' },
];

declare let document: any;

@Injectable()
export class ScriptsService {
  private _scripts: any = {};

  constructor() {
    ScriptStore.forEach((script: Script) => {
      this._scripts[script.name] = {
        loaded: false,
        src: script.src,
      };
    });
  }

  load(...scripts: string[]) {
    const promises: any[] = [];
    scripts.forEach((script: string) =>
      promises.push(
        setTimeout(() => {
          this.loadScript(script);
        }, 700),
      ),
    );
    return Promise.all(promises);
  }

  loadScript(name: string) {
    return new Promise((resolve) => {
      //resolve if already loaded
      if (this._scripts[name]) {
        if (this._scripts[name].loaded) {
          resolve({ script: name, loaded: true, status: 'Already Loaded' });
        } else {
          setTimeout(() => {
            //load script
            const script = document.createElement('script');
            script.type = 'text/javascript';
            script.src = this._scripts[name].src;
            if (script.readyState) {
              //IE
              script.onreadystatechange = () => {
                if (script.readyState === 'loaded' || script.readyState === 'complete') {
                  script.onreadystatechange = null;
                  this._scripts[name].loaded = true;
                  resolve({ script: name, loaded: true, status: 'Loaded' });
                }
              };
            } else {
              //Others
              script.onload = () => {
                this._scripts[name].loaded = true;
                resolve({ script: name, loaded: true, status: 'Loaded' });
              };
            }
            script.onerror = () => resolve({ script: name, loaded: false, status: 'Loaded' });
            document.getElementsByTagName('head')[0].appendChild(script);
          }, 1000);
        }
      }
    });
  }

  loadExternalStyles(styleUrl: string) {
    return new Promise((resolve) => {
      const styleElement = document.createElement('link');
      styleElement.href = styleUrl;
      styleElement.rel = 'stylesheet';
      styleElement.onload = resolve;
      document.getElementsByTagName('head')[0].appendChild(styleElement);
    });
  }
}
